import { QuestionMark } from '@mui/icons-material';
import { SvgIcon, TableRow, Typography } from '@mui/material';

import { Stage } from '../../../../services/entities/impl/blfApi/schemas/stage';
import { FlowerClosedIcon } from '../../../commonUI/icons/FlowerClosedIcon';
import { FlowerOpenIcon } from '../../../commonUI/icons/FlowerOpenIcon';
import { FlowerPetalfallIcon } from '../../../commonUI/icons/FlowerPetalfallIcon';
import { DiagnosticFeature } from '../../../commonUI/viewMode/DiagnosticFeature';
import { SettingsTableCell } from '../../components/SettingsTableCell';
import { ColorSetDisplay } from './ColorSetDisplay';

type Props = {
  stage: Stage;
};

export const StageTableRow = ({ stage }: Props) => {
  if (stage.name === 'Not Expected') {
    return (
      <DiagnosticFeature>
        <TableRow key={stage.id}>
          <SettingsTableCell>{stage.name}</SettingsTableCell>
          <SettingsTableCell
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'flex-start',
            }}
          >
            {getStageIcons(stage)}
          </SettingsTableCell>
        </TableRow>
      </DiagnosticFeature>
    );
  }

  return (
    <TableRow key={stage.id}>
      <SettingsTableCell>{stage.name}</SettingsTableCell>
      <SettingsTableCell
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'flex-start',
        }}
      >
        {getStageIcons(stage)}
      </SettingsTableCell>
    </TableRow>
  );
};

const getStageIcons = (stage: Stage) => {
  const colorSets = stage.colorSets?.length ? (
    <ColorSetDisplay colorSets={stage.colorSets} />
  ) : null;

  const otherIcons = stage.subClasses?.map((subClass) => {
    switch (subClass) {
      case 'closed':
        return (
          <SvgIcon
            viewBox='0 0 14 14'
            sx={{ height: '0.75rem', width: '0.75rem' }}
            key='closed'
          >
            <FlowerClosedIcon />
          </SvgIcon>
        );
      case 'open':
        return (
          <SvgIcon
            viewBox='0 0 14 14'
            sx={{ height: '0.75rem', width: '0.75rem' }}
            key='open'
          >
            <FlowerOpenIcon />
          </SvgIcon>
        );
      case 'petalfall':
        return (
          <SvgIcon
            viewBox='0 0 14 14'
            sx={{ height: '0.75rem', width: '0.75rem' }}
            key='petalfall'
          >
            <FlowerPetalfallIcon />
          </SvgIcon>
        );
      default:
        return (
          <QuestionMark
            sx={{ height: '0.75rem', width: '0.75rem' }}
            key='unknown'
          />
        );
    }
  });

  if (!colorSets && !otherIcons?.length) {
    return <Typography color='textSecondary'>--</Typography>;
  }

  return (
    <>
      {otherIcons}
      {colorSets}
    </>
  );
};
